module.exports = __webpack_public_path__ + "img/solution-ecu-soft-intro.b7be839c.png";